import { Component, Input, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, AvatarModule, MenuModule],
  template: `
    <div class="header-container">
      <div class="header-content">
        <div class="header-left">
          <a [routerLink]="['/']" class="logo-link">
            <img
              src="https://app.careerpathway.com/assets/icon/CareerPathwayHeader.svg"
              alt="careerathway.com"
              class="logo-image"
            />
          </a>
        </div>
        <div class="header-right" *ngIf="isAuthenticated">
          <p-menu #menu [model]="profileItems" [popup]="true"></p-menu>
          @if (profilePhotoDataUri !== null) {
          <p-avatar
            [image]="profilePhotoDataUri"
            shape="circle"
            size="normal"
            styleClass="cursor-pointer"
            (click)="menu.toggle($event)"
          ></p-avatar>
          } @else {
          <p-avatar
            [label]="getUserInitials()"
            shape="circle"
            size="normal"
            styleClass="cursor-pointer"
            (click)="menu.toggle($event)"
          ></p-avatar>
          }
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .header-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background-color: #1a1a1a;
        height: 60px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      }

      .header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        padding: 0 1.5rem;
        max-width: 100%;
      }

      .header-left {
        display: flex;
        align-items: center;
      }

      .logo-link {
        display: flex;
        align-items: center;
        text-decoration: none;
        height: 40px;
      }

      .logo-image {
        height: 40px;
        width: auto;
        max-width: 200px;
      }

      .header-right {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .search-container {
        position: relative;
        display: flex;
        align-items: center;
      }

      .search-input {
        background-color: #2c2c2c;
        border: 1px solid #3a3a3a;
        border-radius: 4px;
        padding: 0.5rem 2.5rem 0.5rem 1rem;
        color: #ffffff;
        font-size: 0.9rem;
        width: 250px;
        outline: none;
        transition: border-color 0.2s ease;
      }

      .search-input:focus {
        border-color: #4a9eff;
      }

      .search-input::placeholder {
        color: #999999;
      }

      .search-icon {
        position: absolute;
        right: 0.75rem;
        color: #999999;
        font-size: 0.9rem;
        pointer-events: none;
      }

      :host ::ng-deep {
        .p-avatar {
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
    `,
  ],
})
export class HeaderComponent implements OnInit {
  @Input() menuItems: MenuItem[] = [];
  @Input() staticMenuItems: MenuItem[] = [];
  @Input() profileItems: MenuItem[] = [];
  @Input() isAuthenticated = false;
  isDarkMode = true;

  profilePhotoDataUri: string | null = null;

  constructor(private authService: AuthService, private router: Router) {}

  @HostListener('window:load')
  @HostListener('window:DOMContentLoaded')
  onLoad() {
    this.detectTheme();
  }

  setProfilePhoto() {
    this.profilePhotoDataUri = this.authService.getAvatar();
  }

  ngOnInit() {
    // Subscribe to auth service for updates (will override @Input if needed)
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
    this.detectTheme();

    this.setProfilePhoto();
    addEventListener(
      'storage',
      (event) => {
        this.setProfilePhoto();
      },
      false
    );
  }

  detectTheme() {
    var classes = document.body.classList;
    const isDarkTheme = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    //this.isDarkMode = isDarkTheme;
  }

  getUserInitials(): string {
    return this.authService.getUserInitials();
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    //document.body.classList.toggle('dark', this.isDarkMode);
  }

  runCommand(item: MenuItem) {
    if (item.command) {
      item.command({ originalEvent: event, item });
    }
  }
}
